<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre15" id="pgepubid00003">MY DISILLUSIONMENT <br class="calibre16"/>IN RUSSIA</h1>
<h2 class="bold sigil_not_in_toc">EMMA GOLDMAN</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?3c18fd40